import {useMediaQuery} from 'react-responsive'

export const Desktop = ({children}) => {
    const isDesktop = useMediaQuery({minWidth: 1024})
    return isDesktop ? children : null
}

export const Mobile = ({children}) => {
    const isMobile = useMediaQuery({maxWidth: 1023})
    return isMobile ? children : null
}

export const isDesktop = () => {
    return useMediaQuery({minWidth: 1024})
}
export const isMobile = () => {
    return useMediaQuery({maxWidth: 1023})
}